import {
  generateMetricDay,
  generateMetricWeek,
  generateMetricMonth,
  generateMetricYear,
  generateDayData,
  generateWeekData,
  generateMonthData,
  generateYearData
} from "utils/generateAnalyticsData";

const routeAnalytics = {
  routeAnalytics: [
    {
      route: "123",
      generalStats: {
        day: {
          avgIncome: "$50K",
          avgPassengers: "2546",
          noOfStops: "10",
          avgNoOfBuses: "10",
          alerts: "124",
        },
        weekly: {
          avgIncome: "$500K",
          avgPassengers: "2846",
          noOfStops: "12",
          avgNoOfBuses: "12",
          alerts: "434",
        },
        monthly: {
          avgIncome: "$560K",
          avgPassengers: "2949",
          noOfStops: "15",
          avgNoOfBuses: "14",
          alerts: "524",
        },
        yearly: {
          avgIncome: "$800K",
          avgPassengers: "3575",
          noOfStops: "18",
          avgNoOfBuses: "15",
          alerts: "824",
        },
      },
      incomeStats: {
        day: {
          avgIncome: "$90K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          avgIncome: "$950K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          avgIncome: "$90K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          avgIncome: "$90K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricYear(),
        },
      },
      passengersStats: {
        day: {
          totalPassengers: "2546",
          observation: "up",
          percentage: "3.0%",

          analyticsData: generateDayData(),
        },
        weekly: {
          totalPassengers: "2846",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalPassengers: "2949",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalPassengers: "3575",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateYearData(),
        },
      },
      fuelEconomyStats: {
        day: {
          fuelEconomy: "70 Miles/Gal",
          analyticsData: generateDayData(),
        },

        weekly: {
          fuelEconomy: "80 Miles/Gal",
          analyticsData: generateWeekData(),
        },
        monthly: {
          fuelEconomy: "90 Miles/Gal",
          analyticsData: generateMonthData(),
        },
        yearly: {
          fuelEconomy: "100 Miles/Gal",
          analyticsData: generateYearData(),
        },
      },
      avgBusesStats: {
        day: {
          buses: "10",
          analyticsData: generateDayData(),
        },
        weekly: {
          buses: "12",
          analyticsData: generateWeekData(),
        },
        monthly: {
          buses: "15",
          analyticsData: generateMonthData(),
        },
        yearly: {
          buses: "18",
          analyticsData: generateYearData(),
        },
      },
      top5BusyRouteStats: {
        analytics: {
          day: generateDayData(1, 8),
          weekly: generateWeekData(1, 10),
          monthly: generateMonthData(1, 15),
          yearly: generateYearData(1, 20),
        },
      },
      stopsStats: {
        day: {
          visited: "87",
          notVisited: "21",
        },
        weekly: {
          visited: "65",
          notVisited: "67",
        },
        monthly: {
          visited: "43",
          notVisited: "56",
        },
        yearly: {
          visited: "79",
          notVisited: "75",
        },
      },
    },
    {
      route: "2",
      generalStats: {
        day: {
          avgIncome: "$52K",
          avgPassengers: "2650",
          noOfStops: "11",
          avgNoOfBuses: "9",
          alerts: "134",
        },
        weekly: {
          avgIncome: "$510K",
          avgPassengers: "2950",
          noOfStops: "13",
          avgNoOfBuses: "11",
          alerts: "414",
        },
        monthly: {
          avgIncome: "$585K",
          avgPassengers: "3100",
          noOfStops: "14",
          avgNoOfBuses: "15",
          alerts: "536",
        },
        yearly: {
          avgIncome: "$820K",
          avgPassengers: "3620",
          noOfStops: "19",
          avgNoOfBuses: "16",
          alerts: "845",
        },
      },
      incomeStats: {
        day: {
          totalIncome: "$52K",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          totalIncome: "$520K",
          observation: "up",
          percentage: "0.8%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          totalIncome: "$610K",
          observation: "up",
          percentage: "1.0%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          totalIncome: "$830K",
          observation: "up",
          percentage: "1.2%",
          analyticsData: generateMetricYear(),
        },
      },
      passengersStats: {
        day: {
          totalPassengers: "5546",
          observation: "up",
          percentage: "3.0%",

          analyticsData: generateDayData(),
        },
        weekly: {
          totalPassengers: "6546",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalPassengers: "7546",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalPassengers: "8546",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateYearData(),
        },
      },
      fuelEconomyStats: {
        day: {
          fuelEconomy: "90 Miles/Gal",
          analyticsData: generateDayData(),
        },
        weekly: {
          fuelEconomy: "100 Miles/Gal",
          analyticsData: generateWeekData(),
        },
        monthly: {
          fuelEconomy: "70 Miles/Gal",
          analyticsData: [
            { node: "2023-07-15T06:00:00", count: 13.0 },
            { node: "2023-07-15T07:00:00", count: 60.0 },
            { node: "2023-07-15T08:00:00", count: 33.0 },
            { node: "2023-07-15T09:00:00", count: 55.0 },
            { node: "2023-07-15T10:00:00", count: 58.0 },
          ],
        },
        yearly: {
          fuelEconomy: "80 Miles/Gal",
          analyticsData: [
            { node: "2023-07-15T06:00:00", count: 19.0 },
            { node: "2023-07-15T07:00:00", count: 70.0 },
            { node: "2023-07-15T08:00:00", count: 23.0 },
            { node: "2023-07-15T09:00:00", count: 65.0 },
            { node: "2023-07-15T10:00:00", count: 18.0 },
          ],
        },
      },
      avgBusesStats: {
        day: {
          buses: "",
          analyticsData: generateDayData(),
        },
        weekly: {
          buses: "",
          analyticsData: generateWeekData(),
        },
        monthly: {
          buses: "",
          analyticsData: generateMonthData(),
        },
        yearly: {
          buses: "",
          analyticsData: generateYearData(),
        },
      },
      top5BusyRouteStats: {
        analytics: {
          day: generateDayData(1, 8),
          weekly: generateWeekData(1, 10),
          monthly: generateMonthData(1, 15),
          yearly: generateYearData(1, 20),
        },
      },
      stopsStats: {
        day: {
          visited: "43",
          notVisited: "67",
        },
        weekly: {
          visited: "90",
          notVisited: "100",
        },
        monthly: {
          visited: "54",
          notVisited: "67",
        },
        yearly: {
          visited: "78",
          notVisited: "91",
        },
      },
    },
    {
      route: "3",
      generalStats: {
        day: {
          avgIncome: "$70K",
          avgPassengers: "2550",
          noOfStops: "11",
          avgNoOfBuses: "11",
          alerts: "125",
        },
        weekly: {
          avgIncome: "$575K",
          avgPassengers: "3547",
          noOfStops: "15",
          avgNoOfBuses: "14",
          alerts: "429",
        },
        monthly: {
          avgIncome: "$662K",
          avgPassengers: "3748",
          noOfStops: "19",
          avgNoOfBuses: "13",
          alerts: "625",
        },
        yearly: {
          avgIncome: "$802K",
          avgPassengers: "4547",
          noOfStops: "18",
          avgNoOfBuses: "21",
          alerts: "926",
        },
      },
      incomeStats: {
        day: {
          totalIncome: "$70K",
          observation: "up",
          percentage: "0.8%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          totalIncome: "$575K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          totalIncome: "$600K",
          observation: "up",
          percentage: "0.7%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          totalIncome: "$8000K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricYear(),
        },
      },
      passengersStats: {
        day: {
          totalPassengers: "2550",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalPassengers: "3547",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalPassengers: "3748",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalPassengers: "4547",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateYearData(),
        },
      },
      fuelEconomyStats: {
        day: {
          fuelEconomy: "70 Miles/Gal",
          analyticsData: generateDayData(),
        },
        weekly: {
          fuelEconomy: "80 Miles/Gal",
          analyticsData: generateWeekData(),
        },
        monthly: {
          fuelEconomy: "90 Miles/Gal",
          analyticsData: generateMonthData(),
        },
        yearly: {
          fuelEconomy: "100 Miles/Gal",
          analyticsData: generateYearData(),
        },
      },
      avgBusesStats: {
        day: {
          buses: "12",
          analyticsData: generateDayData(),
        },
        weekly: {
          buses: "14",
          analyticsData: generateWeekData(),
        },
        monthly: {
          buses: "16",
          analyticsData: generateMonthData(),
        },
        yearly: {
          buses: "18",
          analyticsData: generateYearData(),
        },
      },
      top5BusyRouteStats: {
        analytics: {
          day: generateDayData(1, 8),
          weekly: generateWeekData(1, 10),
          monthly: generateMonthData(1, 15),
          yearly: generateYearData(1, 20),
        },
      },
      stopsStats: {
        day: {
          visited: "54",
          notVisited: "23",
        },
        weekly: {
          visited: "43",
          notVisited: "21",
        },
        monthly: {
          visited: "75",
          notVisited: "32",
        },
        yearly: {
          visited: "97",
          notVisited: "52",
        },
      },
    },
    {
      route: "4",
      generalStats: {
        day: {
          avgIncome: "$80K",
          avgPassengers: "3548",
          noOfStops: "15",
          avgNoOfBuses: "16",
          alerts: "129",
        },
        weekly: {
          avgIncome: "$582K",
          avgPassengers: "3546",
          noOfStops: "18",
          avgNoOfBuses: "16",
          alerts: "524",
        },
        monthly: {
          avgIncome: "$760K",
          avgPassengers: "3546",
          noOfStops: "15",
          avgNoOfBuses: "12",
          alerts: "724",
        },
        yearly: {
          avgIncome: "$800K",
          avgPassengers: "3946",
          noOfStops: "20",
          avgNoOfBuses: "20",
          alerts: "824",
        },
      },
      incomeStats: {
        day: {
          totalIncome: "$80K",
          observation: "up",
          percentage: "0.8%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          totalIncome: "$582K",
          observation: "up",
          percentage: "0.4%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          totalIncome: "$760K",
          observation: "up",
          percentage: "0.8%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          totalIncome: "$800K",
          observation: "up",
          percentage: "0.7%",
          analyticsData: generateMetricYear(),
        },
      },
      passengersStats: {
        day: {
          totalPassengers: "3548",
          observation: "up",
          percentage: "5.0%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalPassengers: "3546",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalPassengers: "3546",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalPassengers: "3946",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateYearData(),
        },
      },
      fuelEconomyStats: {
        day: {
          fuelEconomy: "70 Miles/Gal",
          analyticsData: generateDayData(),
        },
        weekly: {
          fuelEconomy: "80 Miles/Gal",
          analyticsData: generateWeekData(),
        },
        monthly: {
          fuelEconomy: "90 Miles/Gal",
          analyticsData: generateMonthData(),
        },
        yearly: {
          fuelEconomy: "100 Miles/Gal",
          analyticsData: generateYearData(),
        },
      },
      avgBusesStats: {
        day: {
          buses: "12",
          analyticsData: generateDayData(),
        },
        weekly: {
          buses: "15",
          analyticsData: generateWeekData(),
        },
        monthly: {
          buses: "17",
          analyticsData: generateMonthData(),
        },
        yearly: {
          buses: "20",
          analyticsData: generateYearData(),
        },
      },
      top5BusyRouteStats: {
        analytics: {
          day: generateDayData(1, 8),
          weekly: generateWeekData(1, 10),
          monthly: generateMonthData(1, 15),
          yearly: generateYearData(1, 20),
        },
      },
      stopsStats: {
        day: {
          visited: "64",
          notVisited: "78",
        },
        weekly: {
          visited: "73",
          notVisited: "21",
        },
        monthly: {
          visited: "89",
          notVisited: "52",
        },
        yearly: {
          visited: "21",
          notVisited: "45",
        },
      },
    },
    {
      route: "5",
      generalStats: {
        day: {
          avgIncome: "$90K",
          avgPassengers: "2550",
          noOfStops: "12",
          avgNoOfBuses: "13",
          alerts: "134",
        },
        weekly: {
          avgIncome: "$700K",
          avgPassengers: "2946",
          noOfStops: "15",
          avgNoOfBuses: "16",
          alerts: "424",
        },
        monthly: {
          avgIncome: "$800K",
          avgPassengers: "3546",
          noOfStops: "10",
          avgNoOfBuses: "10",
          alerts: "524",
        },
        yearly: {
          avgIncome: "$800K",
          avgPassengers: "2546",
          noOfStops: "10",
          avgNoOfBuses: "10",
          alerts: "624",
        },
      },
      incomeStats: {
        day: {
          totalIncome: "$90K",
          observation: "up",
          percentage: "0.4%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          totalIncome: "$700K",
          observation: "up",
          percentage: "0.7%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          totalIncome: "$800K",
          observation: "up",
          percentage: "0.4%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          totalIncome: "$800K",
          observation: "up",
          percentage: "0.8%",
          analyticsData: generateMetricYear(),
        },
      },
      passengersStats: {
        day: {
          totalPassengers: "2550",
          observation: "up",
          percentage: "5.4%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalPassengers: "2946",
          observation: "down",
          percentage: "2.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalPassengers: "3546",
          observation: "up",
          percentage: "8.5%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalPassengers: "2546",
          observation: "up",
          percentage: "12.3%",
          analyticsData: generateYearData(),
        },
      },
      fuelEconomyStats: {
        day: {
          fuelEconomy: "70 Miles/Gal",
          analyticsData: generateDayData(),
        },
        weekly: {
          fuelEconomy: "80 Miles/Gal",
          analyticsData: generateWeekData(),
        },
        monthly: {
          fuelEconomy: "90 Miles/Gal",
          analyticsData: generateMonthData(),
        },
        yearly: {
          fuelEconomy: "100 Miles/Gal",
          analyticsData: generateYearData(),
        },
      },
      avgBusesStats: {
        day: {
          buses: "12",
          analyticsData: generateDayData(),
        },
        weekly: {
          buses: "15",
          analyticsData: generateWeekData(),
        },
        monthly: {
          buses: "17",
          analyticsData: generateMonthData(),
        },
        yearly: {
          buses: "20",
          analyticsData: generateYearData(),
        },
      },
      top5BusyRouteStats: {
        analytics: {
          day: generateDayData(1, 8),
          weekly: generateWeekData(1, 10),
          monthly: generateMonthData(1, 15),
          yearly: generateYearData(1, 20),
        },
      },
      stopsStats: {
        day: {
          visited: "45",
          notVisited: "23",
        },
        weekly: {
          visited: "62",
          notVisited: "61",
        },
        monthly: {
          visited: "89",
          notVisited: "34",
        },
        yearly: {
          visited: "87",
          notVisited: "56",
        },
      },
    },
    {
      route: "6",
      generalStats: {
        day: {
          avgIncome: "$90K",
          avgPassengers: "2560",
          noOfStops: "12",
          avgNoOfBuses: "12",
          alerts: "124",
        },
        weekly: {
          avgIncome: "$550K",
          avgPassengers: "2546",
          noOfStops: "10",
          avgNoOfBuses: "10",
          alerts: "424",
        },
        monthly: {
          avgIncome: "$600K",
          avgPassengers: "2546",
          noOfStops: "10",
          avgNoOfBuses: "10",
          alerts: "524",
        },
        yearly: {
          avgIncome: "$800K",
          avgPassengers: "2546",
          noOfStops: "10",
          avgNoOfBuses: "10",
          alerts: "624",
        },
      },
      incomeStats: {
        day: {
          totalIncome: "$90K",
          observation: "up",
          percentage: "0.3%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          totalIncome: "$550K",
          observation: "up",
          percentage: "0.4%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          totalIncome: "$600K",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          totalIncome: "$800K",
          observation: "up",
          percentage: "0.4%",
          analyticsData: generateMetricYear(),
        },
      },
      passengersStats: {
        day: {
          totalPassengers: "2556",
          observation: "up",
          percentage: "4.0%",
          analyticsData: generateDayData(),
        },
        weekly: {
          totalPassengers: "3556",
          observation: "up",
          percentage: "5.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalPassengers: "4556",
          observation: "up",
          percentage: "4.0%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalPassengers: "5546",
          observation: "up",
          percentage: "2.0%",
          analyticsData: generateYearData(),
        },
      },
      fuelEconomyStats: {
        day: {
          fuelEconomy: "78 Miles/Gal",
          analyticsData: generateDayData(),
        },
        weekly: {
          fuelEconomy: "85 Miles/Gal",
          analyticsData: generateWeekData(),
        },
        monthly: {
          fuelEconomy: "93 Miles/Gal",
          analyticsData: generateMonthData(),
        },
        yearly: {
          fuelEconomy: "120 Miles/Gal",
          analyticsData: generateYearData(),
        },
      },
      avgBusesStats: {
        day: {
          buses: "5",
          analyticsData: generateDayData(),
        },
        weekly: {
          buses: "12",
          analyticsData: generateWeekData(),
        },
        monthly: {
          buses: "15",
          analyticsData: generateMonthData(),
        },
        yearly: {
          buses: "20",
          analyticsData: generateYearData(),
        },
      },
      top5BusyRouteStats: {
        analytics: {
          day: generateDayData(1, 8),
          weekly: generateWeekData(1, 10),
          monthly: generateMonthData(1, 15),
          yearly: generateYearData(1, 20),
        },
      },
      stopsStats: {
        day: {
          visited: "23",
          notVisited: "45",
        },
        weekly: {
          visited: "67",
          notVisited: "78",
        },
        monthly: {
          visited: "65",
          notVisited: "54",
        },
        yearly: {
          visited: "21",
          notVisited: "54",
        },
      },
    },
    {
      route: "7",
      generalStats: {
        day: {
          avgIncome: "$100K",
          avgPassengers: "2565",
          noOfStops: "12",
          avgNoOfBuses: "12",
          alerts: "126",
        },
        weekly: {
          avgIncome: "$560K",
          avgPassengers: "2546",
          noOfStops: "10",
          avgNoOfBuses: "10",
          alerts: "424",
        },
        monthly: {
          avgIncome: "$70K",
          avgPassengers: "2547",
          noOfStops: "10",
          avgNoOfBuses: "10",
          alerts: "525",
        },
        yearly: {
          avgIncome: "$800K",
          avgPassengers: "2556",
          noOfStops: "10",
          avgNoOfBuses: "10",
          alerts: "624",
        },
      },
      incomeStats: {
        day: {
          totalIncome: "$105K",
          observation: "up",
          percentage: "0.3%",
          analyticsData: generateMetricDay(),
        },
        weekly: {
          totalIncome: "$202K",
          observation: "up",
          percentage: "0.7%",
          analyticsData: generateMetricWeek(),
        },
        monthly: {
          totalIncome: "$310K",
          observation: "up",
          percentage: "0.6%",
          analyticsData: generateMetricMonth(),
        },
        yearly: {
          totalIncome: "$420K",
          observation: "up",
          percentage: "0.5%",
          analyticsData: generateMetricYear(),
        },
      },
      passengersStats: {
        day: {
          totalPassengers: "2566",
          observation: "up",
          percentage: "4.0%",

          analyticsData: generateDayData(),
        },
        weekly: {
          totalPassengers: "3456",
          observation: "up",
          percentage: "5.0%",
          analyticsData: generateWeekData(),
        },
        monthly: {
          totalPassengers: "4556",
          observation: "up",
          percentage: "4.8%",
          analyticsData: generateMonthData(),
        },
        yearly: {
          totalPassengers: "5346",
          observation: "up",
          percentage: "3.0%",
          analyticsData: generateYearData(),
        },
      },
      fuelEconomyStats: {
        day: {
          fuelEconomy: "79 Miles/Gal",
          analyticsData: generateDayData(),
        },
        weekly: {
          fuelEconomy: "95 Miles/Gal",
          analyticsData: generateWeekData(),
        },
        monthly: {
          fuelEconomy: "98 Miles/Gal",
          analyticsData: generateMonthData(),
        },
        yearly: {
          fuelEconomy: "120 Miles/Gal",
          analyticsData: generateYearData(),
        },
      },
      avgBusesStats: {
        day: {
          buses: "",
          analyticsData: generateDayData(),
        },
        weekly: {
          buses: "",
          analyticsData: generateWeekData(),
        },
        monthly: {
          buses: "",
          analyticsData: generateMonthData(),
        },
        yearly: {
          buses: "",
          analyticsData: generateYearData(),
        },
      },
      top5BusyRouteStats: {
        analytics: {
          day: generateDayData(1, 8),
          weekly: generateWeekData(1, 10),
          monthly: generateMonthData(1, 15),
          yearly: generateYearData(1, 20),
        },
      },
      stopsStats: {
        day: {
          visited: "54",
          notVisited: "67",
        },
        weekly: {
          visited: "45",
          notVisited: "87",
        },
        monthly: {
          visited: "45",
          notVisited: "97",
        },
        yearly: {
          visited: "34",
          notVisited: "86",
        },
      },
    },
  ],
  overAllAnalytics: {
    generalStats: {
      day: {
        avgIncome: "$720K",
        avgPassengers: "254665",
        noOfStops: "200",
        avgNoOfBuses: "50",
        alerts: "12432",
      },
      weekly: {
        avgIncome: "$5000K",
        avgPassengers: "2556",
        noOfStops: "10",
        avgNoOfBuses: "10",
        alerts: "426",
      },
      monthly: {
        avgIncome: "$600K",
        avgPassengers: "2548",
        noOfStops: "10",
        avgNoOfBuses: "10",
        alerts: "527",
      },
      yearly: {
        avgIncome: "$8000K",
        avgPassengers: "2546",
        noOfStops: "10",
        avgNoOfBuses: "10",
        alerts: "634",
      },
    },
    incomeStats: {
      day: {
        avgIncome: "$90K",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateMetricDay(),
      },
      weekly: {
        avgIncome: "$350K",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateMetricWeek(),
      },
      monthly: {
        avgIncome: "$600K",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateMetricMonth(),
      },
      yearly: {
        avgIncome: "$750K",
        observation: "up",
        percentage: "0.5%",
        analyticsData: generateMetricYear(),
      },
    },
    passengersStats: {
      day: {
        avgNoOfPassengers: "1546",
        observation: "up",
        percentage: "2.0%",
        analyticsData: generateDayData(),
      },
      weekly: {
        avgNoOfPassengers: "2546",
        observation: "up",
        percentage: "2.0%",
        analyticsData: generateWeekData(),
      },
      monthly: {
        avgNoOfPassengers: "3546",
        observation: "up",
        percentage: "2.0%",
        analyticsData: generateMonthData(),
      },
      yearly: {
        avgNoOfPassengers: "4546",
        observation: "down",
        percentage: "3.0%",
        analyticsData: generateYearData(),
      },
    },
    fuelEconomyStats: {
      day: {
        avgFuelEconomy: "50 Miles/Gal",
        analyticsData: generateDayData(),
      },
      weekly: {
        avgFuelEconomy: "80 Miles/Gal",
        analyticsData: generateWeekData(),
      },
      monthly: {
        avgFuelEconomy: "90 Miles/Gal",
        analyticsData: generateMonthData(),
      },
      yearly: {
        avgFuelEconomy: "100 Miles/Gal",
        analyticsData: generateYearData(),
      },
    },
    avgBusesStats: {
      day: {
        buses: "12",
        analyticsData: generateDayData(),
      },
      weekly: {
        buses: "15",
        analyticsData: generateWeekData(),
      },
      monthly: {
        buses: "17",
        analyticsData: generateMonthData(),
      },
      yearly: {
        buses: "20",
        analyticsData: generateYearData(),
      },
    },
    top5BusyRouteStats: {
      analytics: {
        day: generateDayData(1, 8),
        weekly: generateWeekData(1, 9),
        monthly: generateMonthData(1, 8),
        yearly: generateYearData(1, 8),
      },
    },
    stopsStats: {
      day: {
        visited: "80",
        notVisited: "30",
      },
      weekly: {
        visited: "76",
        notVisited: "85",
      },
      monthly: {
        visited: "34",
        notVisited: "78",
      },
      yearly: {
        visited: "76",
        notVisited: "98",
      },
    },
  },
};
export default routeAnalytics;
